// import React libraries
import { useTranslation } from 'react-i18next';

// import third-party libraries
import {
  Grid,
  Box, AppBar, Toolbar,
  Stack,
  Typography,
  Button
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

// import custom CSS
import '../../css/common.css';

export default function Error() {
  /**
   *  React variables
   */
  const { t } = useTranslation();

  /**
   *  Render the component
   */
  return (
    <Grid className="error" container={true} alignItems="center" justifyContent="center" sx={{ bgcolor: "primary.light" }}>
      <Box sx={{ width: "100%", position: "absolute", top: 0 }}>
        <AppBar className="navbar" position="static" color="secondary">
          <Toolbar>
            <Typography className="logo" variant="h6" component="div" textAlign="center">
              {t("labels.siteName")}
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>

      <Stack direction="column" alignItems="center" justifyContent="center" spacing={3}>
        <img src="/error.webp" alt="maintenance" />
        <Typography variant="h5" color="text.primary">
          {t("msg.exceptionThrown")}
        </Typography>
        <Button variant="contained" href="/" startIcon={<HomeIcon />}>{t("button.backToHome")}</Button>
      </Stack>
    </Grid>
  );
}